import React from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function Docs() {
  return (
    <PageLayout
      title="Developer Documentation"
      subtitle="Deep dive into the Pathfinder API, Collect.js, and Three-Step Redirect logic."
      badge="API REFERENCE"
      imageSrc="/products/art_docs_1776905148564.png"
    >
      <div className="mt-16 space-y-12">
        <div className="bg-gray-900 rounded-3xl overflow-hidden shadow-2xl flex flex-col md:flex-row">
          <div className="p-10 md:w-1/2 flex flex-col justify-center">
            <h3 className="text-2xl font-bold text-white mb-4">Collect.js</h3>
            <p className="text-gray-400 mb-6">Tokenize payment data securely directly from the client browser. Never let raw PAN data touch your servers, achieving the easiest SAQ-A PCI compliance.</p>
            <button className="px-6 py-3 bg-white text-gray-900 font-bold rounded-lg w-fit hover:bg-gray-100 transition-colors">Read the Guide</button>
          </div>
          <div className="bg-gray-950 p-8 md:w-1/2 border-l border-gray-800 font-mono text-sm text-green-400 overflow-x-auto">
            <pre>
              {`CollectJS.configure({
  paymentType: "cc",
  callback: function(response) {
    if (response.error) {
      handleError(response);
    } else {
      submitTokenToServer(response.token);
    }
  }
});`}
            </pre>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
